<template>
  <div class="Page Contacts">
    <h2 class="subtitle">
      Liste des contacts -
      <router-link class="button is-small" :to="'/contact/new'"
        >Ajouter</router-link
      >
    </h2>
    <hr />
    <PaginatedList
      :items="s_contacts"
      :loading="loading"
      :per-page.sync="perPage"
    >
      <template slot="search">
        <horiz-field>
          <label class="label" slot="label">Chercher</label>
          <input type="text" class="input" v-model="query" />
        </horiz-field>
        <help-message>
          <h3 slot="title">Liste des contacts</h3>
          <p>
            Cette liste permet d'accéder aux pages d'édition des contacts déjà
            entrés. <br />Elle n'est pas un carnet de contacts à proprement
            parler, qui est un des supports et interfaces à venir.
          </p>
        </help-message>
      </template>
      <template slot="table-headers">
        <td>
          Nom
          <updown
            :me="$options.sortmodes.BY_LAST_NAME"
            @dir="sort = $event"
            :sort="sort"
          />
        </td>
        <td>
          Diplôme
          <updown
            :me="$options.sortmodes.BY_DIPLOMA"
            @dir="sort = $event"
            :sort="sort"
          />
        </td>
        <td>
          Métier
          <updown
            :me="$options.sortmodes.BY_TRADE"
            @dir="sort = $event"
            :sort="sort"
          />
        </td>
        <td>
          Travaille chez
          <updown
            :me="$options.sortmodes.BY_EMPLOYER"
            @dir="sort = $event"
            :sort="sort"
          />
        </td>
        <td>Actions</td>
      </template>
      <template slot="paginated-listItem" slot-scope="{ paginatedItem }">
        <td>
          <router-link :to="`/contacts/view/${paginatedItem.uuid}`"
            >{{ paginatedItem.first_name }}&nbsp;{{
              paginatedItem.last_name
            }}</router-link
          >
        </td>
        <td>
          <p v-if="paginatedItem.diploma_name">
            {{ paginatedItem.diploma_name }}
          </p>
        </td>
        <td>
          <p v-if="paginatedItem.fonction_name">
            {{ paginatedItem.fonction_name }}
          </p>
        </td>
        <td>
          <p v-if="paginatedItem.partner_name">
            {{ paginatedItem.partner_name }}
          </p>
        </td>
        <td>
          <router-link
            class="is-small"
            :to="`/contact/edit/${paginatedItem.uuid}`"
          >
            éditer&nbsp; <i class="fas fa-edit"></i> </router-link
          >&nbsp;
          <a
            class="is-small has-text-danger"
            @click="deleteContact(paginatedItem)"
            >supprimer</a
          >
        </td>
      </template>
    </PaginatedList>
  </div>
</template>

<script>
import { types as t, sortmodes } from "../../store/actions/contacts";
import { SCARY_MODAL } from "../../store/actions/actions";
import { deepGetKeysC, toKeys, sortAndTailNulls } from "../../util/func";
import HorizField from "../../components/Form/HorizField";
import Updown from "../../components/Form/Updown";
import HelpMessage from "../../components/Form/HelpMessage";
import PaginatedList from "@/components/Layout/PaginatedList";

export default {
  name: "Contacts",
  components: { HelpMessage, PaginatedList, Updown, HorizField },
  data() {
    return {
      loading: false,
      query: "",
      contacts: [],
      perPage: 15,
      sort: {
        mode: sortmodes.BY_ID,
        dir: 0
      }
    };
  },
  sortmodes,
  computed: {
    f_contacts() {
      if (!this.query.toLowerCase().trim()) return this.contacts;
      return this.contacts.filter(
        p =>
          (p.first_name + p.last_name)
            .toLowerCase()
            .indexOf(this.query.toLowerCase().trim()) !== -1
      );
    },
    s_contacts() {
      const keys = toKeys(this.sort.mode);
      const co = this.sort.dir === 0 ? 1 : -1;
      const accessor = deepGetKeysC(keys);
      return sortAndTailNulls(this.f_contacts, accessor, (b, a) => {
        return accessor(a) <= accessor(b) ? -1 * co : co;
      });
    }
  },
  methods: {
    deleteContact(contact) {
      this.$root.$emit(SCARY_MODAL, {
        message: `Voulez-vous vraiment supprimer ${contact.first_name} ${
          contact.last_name
        } ?`,
        action: async () => {
          await this.$store.dispatch(t.DELETE_CONTACT, contact.id);
          return this.fetch();
        }
      });
    },
    async fetch() {
      this.loading = true;
      this.contacts = await this.$store.dispatch(t.GET_CONTACTS);
      this.loading = false;
    }
  },
  async mounted() {
    this.fetch();
  }
};
</script>
